"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerAddonsTable = void 0;
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const react_1 = __importStar(require("react"));
const Badge_1 = __importDefault(require("react-bootstrap/Badge"));
const react_router_dom_1 = require("react-router-dom");
const react_table_1 = require("react-table");
const configContext_1 = require("../../context/configContext");
const dateUtils = __importStar(require("../../utils/dateUtils"));
const ResourceIconWithColor_1 = require("../resource-icon-with-color/ResourceIconWithColor");
require("./ManagerTables.scss");
/**
 * Table for addons. The addons are grouped by day, then by booking.
 */
const ManagerAddonsTable = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const config = (0, configContext_1.useConfig)();
    const columns = (0, react_1.useMemo)(() => {
        const cols = [];
        cols.push({
            Header: "Tag",
            accessor: (row) => {
                const date = new Date(row.dateIso);
                return (react_1.default.createElement("strong", { className: "date-cell" }, dateUtils.WEEKDAYS_SHORT[date.getDay()]));
            },
        });
        cols.push({
            Header: "Datum",
            accessor: (row) => {
                const date = new Date(row.dateIso);
                return (react_1.default.createElement("strong", { className: "date-cell" }, dateUtils.formatDate(date)));
            },
        });
        if (!props.showTotals) {
            cols.push({
                Header: "Referenz",
                accessor: (row) => {
                    var _a;
                    return (react_1.default.createElement("strong", { className: "text-nowrap booking-cell" }, (_a = row.booking) === null || _a === void 0 ? void 0 : _a.reference));
                },
            });
            cols.push({
                Header: "von",
                accessor: (row) => (react_1.default.createElement("span", { className: "booking-cell" }, dateUtils.formatTime(row.booking.start))),
            });
            cols.push({
                Header: "bis",
                accessor: (row) => (react_1.default.createElement("span", { className: "booking-cell" }, dateUtils.formatTime(row.booking.end))),
            });
            cols.push({
                Header: "Ressource",
                accessor: (row) => {
                    var _a;
                    return (react_1.default.createElement(ResourceIconWithColor_1.ResourceIconWithColor, { className: "booking-cell", resource: (_a = row.booking.configResource) !== null && _a !== void 0 ? _a : row.booking.getResourceId() }));
                },
            });
            cols.push({
                Header: "Titel",
                accessor: (row) => (react_1.default.createElement("span", { className: "booking-cell" }, row.booking.title)),
            });
            cols.push({
                Header: "Kontaktperson",
                accessor: (row) => (react_1.default.createElement("span", { className: "booking-cell" }, row.booking.contact.name)),
            });
        }
        cols.push({
            Header: "Kategorie",
            accessor: (row) => react_1.default.createElement(Badge_1.default, { variant: "secondary" }, row.addonType),
        });
        cols.push({
            Header: "Artikel",
            accessor: (row) => react_1.default.createElement("strong", null, row.addonTitle),
        });
        cols.push({
            Header: "Anzahl",
            accessor: (row) => react_1.default.createElement("strong", null, row.addonQuantity),
        });
        cols.push({
            Header: "Einheit",
            accessor: (row) => react_1.default.createElement("strong", null, row.addonUnit),
        });
        return cols;
    }, [props.showTotals]);
    // Prepare data.
    let data = [];
    const bookingsGroupedByDate = (0, groupBy_1.default)(props.bookings, (booking) => dateUtils.formatDateIso(booking.start));
    Object.keys(bookingsGroupedByDate).forEach((dateIso) => {
        const bookings = bookingsGroupedByDate[dateIso];
        bookings.forEach((booking) => {
            const addonsFilteredAndSorted = (0, sortBy_1.default)(booking.addonItems.filter((addon) => props.addonTypesFilter.includes(addon.type)), [(addon) => addon.type, (addon) => addon.title]);
            // Row for each addon of the booking.
            addonsFilteredAndSorted.forEach((addon) => {
                data.push({
                    dateIso,
                    booking,
                    addonType: addon.type,
                    addonTitle: addon.title,
                    addonQuantity: addon.quantity,
                    addonUnit: addon.unit,
                });
            });
        });
    });
    // Reduce if only totals are shown.
    if (props.showTotals) {
        data = data.reduce((accumulator, currentRow) => {
            const sameAddonRow = accumulator.find((row) => row.dateIso === currentRow.dateIso &&
                row.addonType === currentRow.addonType &&
                row.addonTitle === currentRow.addonTitle);
            if (sameAddonRow) {
                // Found a row with same day and same addon -> add quantity.
                sameAddonRow.addonQuantity += currentRow.addonQuantity;
            }
            else {
                // Other day or other addon -> Add it, but without the booking.
                currentRow.booking = undefined;
                accumulator.push(currentRow);
            }
            return accumulator;
        }, []);
    }
    // Sort.
    data = (0, sortBy_1.default)(data, [
        (row) => row.dateIso,
        (row) => (row.booking ? row.booking.start : undefined),
        (row) => (row.booking ? row.booking.reference : undefined),
        (row) => row.addonType,
        (row) => row.addonTitle,
    ]);
    // Init table.
    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = (0, react_table_1.useTable)({
        columns,
        data,
    });
    function handleRowClick(reference) {
        navigate(`/manager/${config.tenantId}/bookings/${reference}/`);
    }
    let previousRowDateIso;
    let previousRowBookingReference;
    let darkStripe = false;
    return (react_1.default.createElement("div", { className: "manager-addons-table table-responsive" },
        react_1.default.createElement("table", { ...getTableProps(), id: "table", className: "table table-sm sticky-header" +
                (props.showTotals ? "" : " table-hover") },
            react_1.default.createElement("thead", null, headerGroups.map((headerGroup) => (react_1.default.createElement("tr", { ...headerGroup.getHeaderGroupProps() }, headerGroup.headers.map((column) => (react_1.default.createElement("th", { ...column.getHeaderProps() }, column.render("Header")))))))),
            react_1.default.createElement("tbody", { ...getTableBodyProps() }, rows.map((row, i) => {
                var _a, _b;
                prepareRow(row);
                // Identify the first row of a new date.
                let firstDateRow = false;
                if (previousRowDateIso !== row.original.dateIso) {
                    firstDateRow = true;
                    previousRowDateIso = row.original.dateIso;
                    // Switch stripe.
                    darkStripe = !darkStripe;
                }
                // Identify the first row of a new booking.
                let firstBookingRow = false;
                if (previousRowBookingReference !== ((_a = row.original.booking) === null || _a === void 0 ? void 0 : _a.reference)) {
                    firstBookingRow = true;
                    previousRowBookingReference = (_b = row.original.booking) === null || _b === void 0 ? void 0 : _b.reference;
                }
                return (react_1.default.createElement("tr", { ...row.getRowProps(), className: (darkStripe ? "dark-stripe" : "") +
                        (firstDateRow ? " first-date-row" : "") +
                        (firstBookingRow ? " first-booking-row" : ""), onClick: () => {
                        var _a;
                        if ((_a = row.original.booking) === null || _a === void 0 ? void 0 : _a.reference) {
                            handleRowClick(row.original.booking.reference);
                        }
                    } }, row.cells.map((cell) => {
                    return (react_1.default.createElement("td", { ...cell.getCellProps() }, cell.render("Cell")));
                })));
            }))),
        data.length === 0 && (react_1.default.createElement("div", { className: "text-center text-secondary" }, "Keine Daten"))));
};
exports.ManagerAddonsTable = ManagerAddonsTable;
